import api from '../service/services.js'

export default {
  name: 'portal',
  data () {
    return {
      menu_list: [],
      menu_all: [],
      sortData: 0,
      bt_sort: 0,
      req_status: 0,
      sort_status: 4
    }
  },
  methods: {
  	GO_to (detail) {
      var obj = { data: { id: detail.app_id} }
      api.update_portal(this.URL_API, obj, 
        (result) => {          
          this.getWeb()
        },
        (error) => {
          alert(JSON.stringify(error))
        }
      )
  	},
    sort_active (index) {
      if(this.key_search != ''){
        this.key_search = ''
      }
      this.bt_sort = index
      if(index < 4){
        this.filter(index)
      }
      this.sort_status = 4
      this.sortedList(this.sort_status)
    },
    search (keyword) {
      this.bt_sort = 0
      this.getWeb(this.bt_sort)
    },
    sortedList(key) { 
      // alert(key)
      switch (parseInt(key)) {
        case 4: return this.menu_list.sort((a, b) => a.app_name > b.app_name )
          break
        case 5: return this.menu_list.sort((a, b) => a.app_name < b.app_name )
          break
        case 6: return this.menu_list.sort((a,b) => b.app_count - a.app_count)
      }
    },
    filter (key) {
      switch (parseInt(key)) {
        case 0 : this.key_search = ''; this.filter_all()// this.getWeb(this.bt_sort)
          break
        case 1 : this.menu_list = this.menu_all; this.filter_teacher()
          break
        case 2 : this.menu_list = this.menu_all; this.filter_personnel()
          break
        case 3 : this.menu_list = this.menu_all; this.filter_student() 
      }
    },
    filter_all () {
       this.menu_list.forEach(function(val, key){
          val['show'] = 1
      }.bind(this))
    },
    filter_teacher () {
      this.menu_list.forEach(function(val, key){
        if(val['teacher_type'] == 1){
          val['show'] = 1
        }else{
          val['show'] = 0
        }
      }.bind(this))
    },
    filter_personnel () {
      this.menu_list.forEach(function(val, key){
        if(val['personnel_type'] == 1){
          val['show'] = 1
        }else{
          val['show'] = 0
        }
      }.bind(this))
    },
    filter_student () {
      this.menu_list.forEach(function(val, key){
        if(val['student_type'] == 1){
          val['show'] = 1
        }else{
          val['show'] = 0
        }
      }.bind(this))
    }
  },
  computed: {
    listFilter () {
      let text = this.key_search.trim()
      return this.menu_list.filter(item => {
        return item.app_name.indexOf(text) > -1 || item.app_link.indexOf(text) > -1 || item.app_discription.indexOf(text) > -1
      })
    }
  },
  mounted () {
  	this.getWeb(this.bt_sort)
    var contianer = document.getElementsByClassName('contianer')
    for(var i = 0; i < contianer.length; i++){
      contianer[i].style.height = screen.availHeight + 'px'
    }
    document.getElementById("team").style.display = "block"
  }
}


// WEBPACK FOOTER //
// ./src/js/index.js